import XRegExp from 'xregexp';

import { ValidatorConstraintInterface, ValidatorConstraint } from 'class-validator';

// eslint-disable-next-line
const notAlphaNumericMatcher = XRegExp(`^[^\\p{L}\\w]|[^\\p{L}\\w]$`);

@ValidatorConstraint({ name: 'Words' })
export class WordsAreValid implements ValidatorConstraintInterface {
  validate(currentValue: string) {
    const values = currentValue.split(',');
    for (let i = 0; i < values.length; i++) {
      const v = values[i].trim();
      if (notAlphaNumericMatcher.test(v)) {
        return false;
      }
    }

    return true;
  }

  defaultMessage() {
    return 'Values cannot start or end with a special character';
  }
}
